module.exports = __webpack_public_path__ + "static/media/jakub_profile_pic.705dbf71.png";